import { ReturnTextAndImg } from "../../test/CheckImg"
import Score from "../test-creator/Score"
import {ru} from "../../data/ru";
import {by} from "../../data/by";
import {ReactComponent as ArrowIcon} from "../../../img/arrow-feedback.svg";

export default function ComplexTaskQuestions({questions, deleteQ, changeScores,upFunction,downFunction}) {
  let language = localStorage.getItem('lang') === 'ru' ?  ru.RoleIdThree: by.RoleIdThree;
  const questionsJSX = questions.map((item,index) => {
    const text = ReturnTextAndImg(item.description,{maxHeight:'50px'})

    return (
    <div key={`visible${item.id}`} className="test-creator-one-question">
      <div className="test-creator-question-create">
        <button onClick={(e) => deleteQ(e, item.id)} className="test-creator-test-closeButton">&times;</button>
        {/*<p className="test-creator-test-question-p">{item.description}</p> */}
        <div className="test-creator-test-question-p">{text}</div>
        <div className="test-creator-up-down-button">
          <span onClick={()=>upFunction(index)}><ArrowIcon className={'upArrow'}/></span>
          <span onClick={()=>downFunction(index)}><ArrowIcon/></span>
        </div>
      </div>
      <div className="test-creator-score-create">
        <p> {language.howManyPoint}: </p>
        <Score id={item.id} changeScores={changeScores} defaultScore={item.score} />
      </div>
    </div>
    )
  })

  return (
    <>
      <p> {language.questionsOfAComplexTask}: </p>
      {questionsJSX}
    </>
  )
}